
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalSphere as ObiBuoySphericalSphereElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-sphere.js';
 
 
 

 
 export const ObiBuoySphericalSphere = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-sphere',
   elementClass: ObiBuoySphericalSphereElement,
   events: {
     
   }
  });
 
 